// import React, { useState, useEffect, useRef } from 'react';
// import { 
//   Minimize2, 
//   Maximize2, 
//   X as CloseIcon, 
//   ChevronLeft, 
//   ChevronRight,
//   ZoomIn,
//   ZoomOut,
//   RotateCw,
//   Move,
//   Maximize
// } from 'lucide-react';
// import { Document, Page, pdfjs } from 'react-pdf';

// // Set workerSrc for pdfjs
// pdfjs.GlobalWorkerOptions.workerSrc = 
//   'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs';

// const PDFPreviewModal = ({
//   previewOpen,
//   formData,
//   isFullscreen,
//   setIsFullscreen,
//   handleClosePreview,
//   currentSlideNumber,
//   trackAnalytics,
//   analytics,
//   iframeRef
// }) => {
//   const [numPages, setNumPages] = useState(null);
//   const [pageNumber, setPageNumber] = useState(1);
//   const [scale, setScale] = useState(1);
//   const [rotation, setRotation] = useState(0);
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
//   const [translate, setTranslate] = useState({ x: 0, y: 0 });
//   const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
//   const [fitMode, setFitMode] = useState('width'); // 'width', 'height', 'page'
  
//   const containerRef = useRef(null);
//   const pageRef = useRef(null);

//   useEffect(() => {
//     if (previewOpen) {
//       setPageNumber(1);
//       setScale(1);
//       setRotation(0);
//       setTranslate({ x: 0, y: 0 });
//       updateContainerSize();
//       // Auto-fit to page when modal opens
//       setTimeout(() => {
//         handleFitToPage();
//       }, 100);
//     }
//   }, [previewOpen]);

//   useEffect(() => {
//     const handleResize = () => {
//       updateContainerSize();
//       // Re-apply current fit mode after resize
//       setTimeout(() => {
//         if (fitMode === 'width') {
//           handleFitToWidth();
//         } else if (fitMode === 'page') {
//           handleFitToPage();
//         }
//       }, 100);
//     };
//     window.addEventListener('resize', handleResize);
//     window.addEventListener('orientationchange', handleResize);
//     return () => {
//       window.removeEventListener('resize', handleResize);
//       window.removeEventListener('orientationchange', handleResize);
//     };
//   }, [fitMode, rotation, containerSize]);

//   useEffect(() => {
//     if (currentSlideNumber && currentSlideNumber.current !== pageNumber) {
//       currentSlideNumber.current = pageNumber;
//     }
//   }, [pageNumber, currentSlideNumber]);

//   const updateContainerSize = () => {
//     if (containerRef.current) {
//       const rect = containerRef.current.getBoundingClientRect();
//       setContainerSize({ width: rect.width, height: rect.height });
//     }
//   };

//   const onDocumentLoadSuccess = ({ numPages }) => {
//     setNumPages(numPages);
//     updateContainerSize();
//     trackAnalytics && trackAnalytics('pdf_loaded_successfully', {
//       fileName: formData.pitchDeck.fileName,
//       totalPages: numPages,
//       isFullscreen: isFullscreen
//     });
//   };

//   const goToPrevPage = () => {
//     setPageNumber(prev => Math.max(1, prev - 1));
//     setTranslate({ x: 0, y: 0 });
//   };

//   const goToNextPage = () => {
//     setPageNumber(prev => Math.min(numPages, prev + 1));
//     setTranslate({ x: 0, y: 0 });
//   };

//   const handleZoomIn = () => {
//     setScale(prev => Math.min(3, prev + 0.25));
//   };

//   const handleZoomOut = () => {
//     setScale(prev => Math.max(0.1, prev - 0.25));
//   };

//   const handleRotate = () => {
//     setRotation(prev => (prev + 90) % 360);
//     setTranslate({ x: 0, y: 0 });
//   };

//   const handleFitToWidth = () => {
//     if (containerSize.width > 0) {
//       // Account for padding and use actual PDF width
//       const availableWidth = containerSize.width - 40;
//       const pdfWidth = rotation % 180 === 0 ? 595 : 842; // Swap dimensions when rotated
//       const newScale = availableWidth / pdfWidth;
//       setScale(Math.min(3, Math.max(0.1, newScale)));
//       setTranslate({ x: 0, y: 0 });
//       setFitMode('width');
//     }
//   };

//   const handleFitToPage = () => {
//     if (containerSize.width > 0 && containerSize.height > 0) {
//       // Account for padding
//       const availableWidth = containerSize.width - 40;
//       const availableHeight = containerSize.height - 40;
      
//       // PDF dimensions (swap when rotated)
//       const pdfWidth = rotation % 180 === 0 ? 595 : 842;
//       const pdfHeight = rotation % 180 === 0 ? 842 : 595;
      
//       // Calculate scale to fit both dimensions
//       const scaleX = availableWidth / pdfWidth;
//       const scaleY = availableHeight / pdfHeight;
//       const newScale = Math.min(scaleX, scaleY);
      
//       setScale(Math.min(3, Math.max(0.1, newScale)));
//       setTranslate({ x: 0, y: 0 });
//       setFitMode('page');
//     }
//   };

//   const handleMouseDown = (e) => {
//     if (scale > 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.clientX - translate.x,
//         y: e.clientY - translate.y
//       });
//     }
//   };

//   const handleMouseMove = (e) => {
//     if (isDragging && scale > 1) {
//       setTranslate({
//         x: e.clientX - dragStart.x,
//         y: e.clientY - dragStart.y
//       });
//     }
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const handleTouchStart = (e) => {
//     if (scale > 1 && e.touches.length === 1) {
//       setIsDragging(true);
//       setDragStart({
//         x: e.touches[0].clientX - translate.x,
//         y: e.touches[0].clientY - translate.y
//       });
//     }
//   };

//   const handleTouchMove = (e) => {
//     if (isDragging && scale > 1 && e.touches.length === 1) {
//       e.preventDefault();
//       setTranslate({
//         x: e.touches[0].clientX - dragStart.x,
//         y: e.touches[0].clientY - dragStart.y
//       });
//     }
//   };

//   const handleTouchEnd = () => {
//     setIsDragging(false);
//   };

//   if (!previewOpen || !formData.pitchDeck.url) return null;

//   const isMobile = window.innerWidth < 768;

//   return (
//     <div className={`fixed inset-0 z-50 bg-black transition-all duration-300 ${isFullscreen ? 'p-0' : 'p-2 sm:p-4 bg-black/80'}`}>
//       <div className={`${isFullscreen ? 'w-full h-full' : 'bg-white rounded-2xl shadow-2xl w-full max-w-6xl h-[95vh] mx-auto'} flex flex-col`}>
//         {/* Header */}
//         <div className={`flex items-center justify-between p-2 sm:p-4 ${isFullscreen ? 'bg-gray-900 text-white' : 'border-b bg-white'} flex-shrink-0`}>
//           <div className="flex items-center gap-2 sm:gap-4 min-w-0">
//             <div className="min-w-0">
//               <h3 className={`text-sm sm:text-lg font-semibold truncate ${isFullscreen ? 'text-white' : 'text-gray-900'}`}>
//                 {formData.pitchDeck.fileName}
//               </h3>
//               <p className={`text-xs sm:text-sm ${isFullscreen ? 'text-gray-300' : 'text-gray-500'}`}>
//                 {numPages ? `Page ${pageNumber} of ${numPages}` : 'Loading...'}
//               </p>
//             </div>
//           </div>
//           <div className="flex items-center gap-1">
//             <button 
//               onClick={() => setIsFullscreen(!isFullscreen)} 
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors ${isFullscreen ? 'text-white hover:bg-gray-800' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'}`}
//             >
//               {isFullscreen ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
//             </button>
//             <button 
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors ${isFullscreen ? 'text-white hover:bg-gray-800' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'}`} 
//               onClick={handleClosePreview}
//             >
//               <CloseIcon className="w-4 h-4" />
//             </button>
//           </div>
//         </div>

//         {/* Controls */}
//         <div className={`flex items-center justify-between p-2 sm:p-3 border-b ${isFullscreen ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} flex-shrink-0`}>
//           <div className="flex items-center gap-1 sm:gap-2">
//             {/* Navigation */}
//             <button 
//               onClick={goToPrevPage} 
//               disabled={pageNumber <= 1}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//             >
//               <ChevronLeft className="w-4 h-4" />
//             </button>
//             <button 
//               onClick={goToNextPage} 
//               disabled={pageNumber >= numPages}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//             >
//               <ChevronRight className="w-4 h-4" />
//             </button>
            
//             {/* Divider */}
//             <div className={`h-6 w-px ${isFullscreen ? 'bg-gray-600' : 'bg-gray-300'} mx-1`} />
            
//             {/* Zoom */}
//             <button 
//               onClick={handleZoomOut}
//               disabled={scale <= 0.1}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//             >
//               <ZoomOut className="w-4 h-4" />
//             </button>
//             <span className={`text-xs sm:text-sm font-mono px-1 ${isFullscreen ? 'text-gray-300' : 'text-gray-600'}`}>
//               {Math.round(scale * 100)}%
//             </span>
//             <button 
//               onClick={handleZoomIn}
//               disabled={scale >= 3}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//             >
//               <ZoomIn className="w-4 h-4" />
//             </button>
//           </div>

//           <div className="flex items-center gap-1 sm:gap-2">
//             {/* Fit buttons */}
//             <button 
//               onClick={handleFitToWidth}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//               title="Fit to width"
//             >
//               <span className="text-xs font-medium">W</span>
//             </button>
//             <button 
//               onClick={handleFitToPage}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//               title="Fit to page"
//             >
//               <Maximize className="w-4 h-4" />
//             </button>
//             <button 
//               onClick={handleRotate}
//               className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
//                 isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
//               }`}
//             >
//               <RotateCw className="w-4 h-4" />
//             </button>
//           </div>
//         </div>

//         {/* PDF Viewer */}
//         <div 
//           ref={containerRef}
//           className={`flex-1 overflow-hidden ${isFullscreen ? 'bg-gray-900' : 'bg-gray-100'} relative`}
//           onMouseDown={handleMouseDown}
//           onMouseMove={handleMouseMove}
//           onMouseUp={handleMouseUp}
//           onMouseLeave={handleMouseUp}
//           onTouchStart={handleTouchStart}
//           onTouchMove={handleTouchMove}
//           onTouchEnd={handleTouchEnd}
//           style={{ cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default' }}
//         >
//           <div className="flex items-center justify-center h-full p-4">
//             <div 
//               style={{
//                 transform: `translate(${translate.x}px, ${translate.y}px)`,
//                 transition: isDragging ? 'none' : 'transform 0.1s ease-out'
//               }}
//             >
//               <Document
//                 file={formData.pitchDeck.url}
//                 onLoadSuccess={onDocumentLoadSuccess}
//                 loading={
//                   <div className="flex items-center justify-center bg-white rounded-lg shadow-lg p-8 min-w-[300px] min-h-[400px]">
//                     <div className="text-center">
//                       <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
//                       <div className="text-lg font-medium text-gray-700">Loading PDF...</div>
//                       <div className="text-sm text-gray-500 mt-1">Please wait</div>
//                     </div>
//                   </div>
//                 }
//                 error={
//                   <div className="flex items-center justify-center bg-white rounded-lg shadow-lg p-8 min-w-[300px] min-h-[400px]">
//                     <div className="text-center text-gray-600">
//                       <div className="text-lg font-medium mb-2">Failed to load PDF</div>
//                       <div className="text-sm">Please try again or contact support</div>
//                     </div>
//                   </div>
//                 }
//               >
//                 <Page
//                   ref={pageRef}
//                   pageNumber={pageNumber}
//                   scale={scale}
//                   rotate={rotation}
//                   renderTextLayer={false}
//                   renderAnnotationLayer={false}
//                   className="shadow-lg rounded-lg overflow-hidden bg-white"
//                 />
//               </Document>
//             </div>
//           </div>

//           {/* Page indicator overlay for mobile */}
//           {isMobile && numPages && (
//             <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-3 py-1 rounded-full text-sm">
//               {pageNumber} / {numPages}
//             </div>
//           )}

//           {/* Help text */}
//           {scale > 1 && (
//             <div className="absolute top-4 right-4 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
//               {isMobile ? 'Drag to pan' : 'Click and drag to pan'}
//             </div>
//           )}
//         </div>

//         {/* Mobile swipe hint */}
//         {isMobile && numPages > 1 && (
//           <div className={`text-center py-2 text-xs ${isFullscreen ? 'text-gray-400 bg-gray-800' : 'text-gray-500 bg-gray-50'}`}>
//             Use navigation buttons or swipe to change pages
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PDFPreviewModal;
import React, { useState, useEffect, useRef } from 'react';
import { 
  Minimize2, 
  Maximize2, 
  X, 
  ChevronLeft, 
  ChevronRight,
  ZoomIn,
  ZoomOut,
  RotateCw,
  Move,
  Maximize,
  Menu,
  Sidebar,
  Monitor,
  Smartphone
} from 'lucide-react';
import { Document, Page, pdfjs } from 'react-pdf';

// Set workerSrc for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc = 
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.8.69/pdf.worker.min.mjs';

const PDFPreviewModal = ({
  previewOpen,
  formData,
  isFullscreen,
  setIsFullscreen,
  handleClosePreview,
  currentSlideNumber,
  trackAnalytics,
  analytics,
  iframeRef
}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const [fitMode, setFitMode] = useState('width');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [viewMode, setViewMode] = useState('landscape'); // 'landscape' or 'portrait'
  const [touchStart, setTouchStart] = useState({ x: 0, y: 0 });
  const [touchEnd, setTouchEnd] = useState({ x: 0, y: 0 });
  
  const containerRef = useRef(null);
  const pageRef = useRef(null);
  const sidebarRef = useRef(null);

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (previewOpen) {
      setPageNumber(1);
      setScale(1);
      setRotation(0);
      setTranslate({ x: 0, y: 0 });
      setSidebarOpen(!isMobile); // Open sidebar by default on desktop
      updateContainerSize();
      // Auto-fit to page when modal opens
      setTimeout(() => {
        handleFitToPage();
      }, 100);
    }
  }, [previewOpen]);

  // Keyboard navigation effect
  useEffect(() => {
    if (!previewOpen) return;
    
    const handleKeyDown = (e) => {
      // Only handle keyboard navigation on desktop
      if (isMobile) return;
      
      switch (e.key) {
        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          goToPrevPage();
          break;
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          goToNextPage();
          break;
        case 'Home':
          e.preventDefault();
          goToPage(1);
          break;
        case 'End':
          e.preventDefault();
          if (numPages) goToPage(numPages);
          break;
        case 'Escape':
          e.preventDefault();
          handleClosePreview();
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [previewOpen, isMobile, numPages]);

  useEffect(() => {
    const handleResize = () => {
      updateContainerSize();
      // Re-apply current fit mode after resize
      setTimeout(() => {
        if (fitMode === 'width') {
          handleFitToWidth();
        } else if (fitMode === 'page') {
          handleFitToPage();
        }
      }, 100);
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [fitMode, rotation, containerSize]);

  useEffect(() => {
    if (currentSlideNumber && currentSlideNumber.current !== pageNumber) {
      currentSlideNumber.current = pageNumber;
    }
  }, [pageNumber, currentSlideNumber]);

  const updateContainerSize = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setContainerSize({ width: rect.width, height: rect.height });
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    updateContainerSize();
    trackAnalytics && trackAnalytics('pdf_loaded_successfully', {
      fileName: formData.pitchDeck.fileName,
      totalPages: numPages,
      isFullscreen: isFullscreen
    });
  };

  const goToPrevPage = () => {
    setPageNumber(prev => Math.max(1, prev - 1));
    setTranslate({ x: 0, y: 0 });
  };

  const goToNextPage = () => {
    setPageNumber(prev => Math.min(numPages, prev + 1));
    setTranslate({ x: 0, y: 0 });
  };

  const goToPage = (page) => {
    setPageNumber(page);
    setTranslate({ x: 0, y: 0 });
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  const handleZoomIn = () => {
    setScale(prev => Math.min(3, prev + 0.1));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(0.1, prev - 0.1));
  };

  const handleRotate = () => {
    setRotation(prev => (prev + 90) % 360);
    setTranslate({ x: 0, y: 0 });
  };

  const toggleViewMode = () => {
    setViewMode(prev => prev === 'landscape' ? 'portrait' : 'landscape');
    setTranslate({ x: 0, y: 0 });
    setTimeout(() => {
      handleFitToPage();
    }, 100);
  };

  const handleFitToWidth = () => {
    if (containerSize.width > 0) {
      const availableWidth = containerSize.width - 40;
      const pdfWidth = rotation % 180 === 0 ? 595 : 842;
      const newScale = availableWidth / pdfWidth;
      setScale(Math.min(3, Math.max(0.1, newScale)));
      setTranslate({ x: 0, y: 0 });
      setFitMode('width');
    }
  };

  const handleFitToPage = () => {
    if (containerSize.width > 0 && containerSize.height > 0) {
      const availableWidth = containerSize.width - 40;
      const availableHeight = containerSize.height - 40;
      
      const pdfWidth = rotation % 180 === 0 ? 595 : 842;
      const pdfHeight = rotation % 180 === 0 ? 842 : 595;
      
      const scaleX = availableWidth / pdfWidth;
      const scaleY = availableHeight / pdfHeight;
      const newScale = Math.min(scaleX, scaleY);
      
      setScale(Math.min(3, Math.max(0.1, newScale)));
      setTranslate({ x: 0, y: 0 });
      setFitMode('page');
    }
  };

  const handleMouseDown = (e) => {
    if (scale > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - translate.x,
        y: e.clientY - translate.y
      });
    }
  };

  const handleMouseMove = (e) => {
    if (isDragging && scale > 1) {
      setTranslate({
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y
      });
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    if (isMobile && e.touches.length === 1) {
      const touch = e.touches[0];
      setTouchStart({ x: touch.clientX, y: touch.clientY });
      
      // If zoomed in, handle panning
      if (scale > 1) {
        setIsDragging(true);
        setDragStart({
          x: touch.clientX - translate.x,
          y: touch.clientY - translate.y
        });
      }
    }
  };

  const handleTouchMove = (e) => {
    if (isMobile && e.touches.length === 1) {
      const touch = e.touches[0];
      setTouchEnd({ x: touch.clientX, y: touch.clientY });
      
      // If zoomed in and dragging, handle panning
      if (isDragging && scale > 1) {
        e.preventDefault();
        setTranslate({
          x: touch.clientX - dragStart.x,
          y: touch.clientY - dragStart.y
        });
      }
    }
  };

  const handleTouchEnd = (e) => {
    if (!isMobile) return;
    
    setIsDragging(false);
    
    // Only handle swipe if not zoomed in (to avoid conflict with panning)
    if (scale <= 1 && touchStart.x && touchEnd.x) {
      const deltaX = touchStart.x - touchEnd.x;
      const deltaY = Math.abs(touchStart.y - touchEnd.y);
      const minSwipeDistance = 50;
      
      // Only register horizontal swipes (ignore vertical scrolling)
      if (Math.abs(deltaX) > minSwipeDistance && deltaY < 100) {
        if (deltaX > 0) {
          // Swiped left - go to next page
          goToNextPage();
        } else {
          // Swiped right - go to previous page
          goToPrevPage();
        }
      }
    }
    
    // Reset touch positions
    setTouchStart({ x: 0, y: 0 });
    setTouchEnd({ x: 0, y: 0 });
  };

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  // Sidebar component
  const NavigationSidebar = () => (
    <div 
      ref={sidebarRef}
      className={`${
        isFullscreen ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
      } border-r transition-all duration-300 ${
        sidebarOpen ? 'w-64 opacity-100' : 'w-0 opacity-0 overflow-hidden'
      } flex flex-col`}
    >
      <div className={`p-3 border-b ${isFullscreen ? 'border-gray-700' : 'border-gray-200'} flex-shrink-0`}>
        <div className="flex items-center justify-between">
          <h4 className={`font-medium text-sm ${isFullscreen ? 'text-white' : 'text-gray-900'}`}>
            Pages ({numPages || 0})
          </h4>
          {isMobile && (
            <button
              onClick={toggleSidebar}
              className={`p-1 rounded ${isFullscreen ? 'text-gray-300 hover:bg-gray-700' : 'text-gray-500 hover:bg-gray-100'}`}
            >
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto p-2 space-y-2">
        {numPages && Array.from({ length: numPages }, (_, i) => i + 1).map((page) => (
          <div
            key={page}
            onClick={() => goToPage(page)}
            className={`relative cursor-pointer rounded-lg border-2 transition-all ${
              page === pageNumber
                ? (isFullscreen ? 'border-blue-400 bg-blue-900/20' : 'border-blue-500 bg-blue-50')
                : (isFullscreen ? 'border-gray-600 hover:border-gray-500' : 'border-gray-200 hover:border-gray-300')
            } p-2 group`}
          >
            <div className="aspect-[3/4] bg-white rounded overflow-hidden mb-2">
              <Document
                file={formData.pitchDeck.url}
                loading={
                  <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400"></div>
                  </div>
                }
                error={
                  <div className="w-full h-full bg-gray-100 flex items-center justify-center text-xs text-gray-500">
                    Error
                  </div>
                }
              >
                <Page
                  pageNumber={page}
                  scale={0.2}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  className="w-full h-full"
                />
              </Document>
            </div>
            <div className={`text-xs text-center ${
              page === pageNumber
                ? (isFullscreen ? 'text-blue-300' : 'text-blue-600')
                : (isFullscreen ? 'text-gray-300' : 'text-gray-600')
            }`}>
              Page {page}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (!previewOpen || !formData.pitchDeck.url) return null;

  return (
    <div className={`fixed inset-0 z-50 bg-black transition-all duration-300 ${isFullscreen ? 'p-0' : 'p-2 sm:p-4 bg-black/80'}`}>
      <div className={`${isFullscreen ? 'w-full h-full' : 'bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[95vh] mx-auto'} flex flex-col`}>
        {/* Header */}
        <div className={`flex items-center justify-between p-2 sm:p-4 ${isFullscreen ? 'bg-gray-900 text-white' : 'border-b bg-white'} flex-shrink-0`}>
          <div className="flex items-center gap-2 sm:gap-4 min-w-0">
            <button
              onClick={toggleSidebar}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
                isFullscreen ? 'text-white hover:bg-gray-800' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'
              }`}
            >
              <Menu className="w-4 h-4" />
            </button>
            <div className="min-w-0">
              <h3 className={`text-sm sm:text-lg font-semibold truncate ${isFullscreen ? 'text-white' : 'text-gray-900'}`}>
                {formData.pitchDeck.fileName}
              </h3>
              <p className={`text-xs sm:text-sm ${isFullscreen ? 'text-gray-300' : 'text-gray-500'}`}>
                {numPages ? `Page ${pageNumber} of ${numPages}` : 'Loading...'}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <button 
              onClick={() => setIsFullscreen(!isFullscreen)} 
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${isFullscreen ? 'text-white hover:bg-gray-800' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'}`}
            >
              {isFullscreen ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
            </button>
            <button 
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${isFullscreen ? 'text-white hover:bg-gray-800' : 'text-gray-400 hover:text-gray-700 hover:bg-gray-100'}`} 
              onClick={handleClosePreview}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Controls */}
        <div className={`flex items-center justify-between p-2 sm:p-3 border-b ${isFullscreen ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} flex-shrink-0`}>
          <div className="flex items-center gap-1 sm:gap-2">
            {/* Navigation */}
            <button 
              onClick={goToPrevPage} 
              disabled={pageNumber <= 1}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            <button 
              onClick={goToNextPage} 
              disabled={pageNumber >= numPages}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
            >
              <ChevronRight className="w-4 h-4" />
            </button>
            
            {/* Divider */}
            <div className={`h-6 w-px ${isFullscreen ? 'bg-gray-600' : 'bg-gray-300'} mx-1`} />
            
            {/* Zoom */}
            <button 
              onClick={handleZoomOut}
              disabled={scale <= 0.1}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
            >
              <ZoomOut className="w-4 h-4" />
            </button>
            <span className={`text-xs sm:text-sm font-mono px-1 min-w-[3rem] text-center ${isFullscreen ? 'text-gray-300' : 'text-gray-600'}`}>
              {Math.round(scale * 100)}%
            </span>
            <button 
              onClick={handleZoomIn}
              disabled={scale >= 3}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
            >
              <ZoomIn className="w-4 h-4" />
            </button>
          </div>

          <div className="flex items-center gap-1 sm:gap-2">
            {/* View mode toggle */}
            <button 
              onClick={toggleViewMode}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
              title={`Switch to ${viewMode === 'landscape' ? 'portrait' : 'landscape'} view`}
            >
              {viewMode === 'landscape' ? <Smartphone className="w-4 h-4" /> : <Monitor className="w-4 h-4" />}
            </button>
            
            {/* Fit buttons */}
            <button 
              onClick={handleFitToWidth}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
              title="Fit to width"
            >
              <span className="text-xs font-medium">W</span>
            </button>
            <button 
              onClick={handleFitToPage}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
              title="Fit to page"
            >
              <Maximize className="w-4 h-4" />
            </button>
            <button 
              onClick={handleRotate}
              className={`p-1.5 sm:p-2 rounded-lg transition-colors ${
                isFullscreen ? 'text-white hover:bg-gray-700' : 'text-gray-600 hover:bg-gray-200'
              }`}
            >
              <RotateCw className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Main content area */}
        <div className="flex flex-1 overflow-hidden">
          {/* Navigation Sidebar */}
          <NavigationSidebar />
          
          {/* PDF Viewer */}
          <div 
            ref={containerRef}
            className={`flex-1 overflow-hidden ${isFullscreen ? 'bg-gray-900' : 'bg-gray-100'} relative`}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{ cursor: scale > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default' }}
          >
            <div className={`flex items-center justify-center h-full p-4 ${
              viewMode === 'portrait' ? 'flex-col' : ''
            }`}>
              <div 
                style={{
                  transform: `translate(${translate.x}px, ${translate.y}px)`,
                  transition: isDragging ? 'none' : 'transform 0.1s ease-out'
                }}
              >
                <Document
                  file={formData.pitchDeck.url}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={
                    <div className="flex items-center justify-center bg-white rounded-lg shadow-lg p-8 min-w-[300px] min-h-[400px]">
                      <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                        <div className="text-lg font-medium text-gray-700">Loading PDF...</div>
                        <div className="text-sm text-gray-500 mt-1">Please wait</div>
                      </div>
                    </div>
                  }
                  error={
                    <div className="flex items-center justify-center bg-white rounded-lg shadow-lg p-8 min-w-[300px] min-h-[400px]">
                      <div className="text-center text-gray-600">
                        <div className="text-lg font-medium mb-2">Failed to load PDF</div>
                        <div className="text-sm">Please try again or contact support</div>
                      </div>
                    </div>
                  }
                >
                  <Page
                    ref={pageRef}
                    pageNumber={pageNumber}
                    scale={scale}
                    rotate={rotation}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    className="shadow-lg rounded-lg overflow-hidden bg-white"
                  />
                </Document>
              </div>
            </div>

            {/* Page indicator overlay for mobile */}
            {isMobile && numPages && !sidebarOpen && (
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-70 text-white px-3 py-1 rounded-full text-sm flex items-center gap-2">
                <span>{pageNumber} / {numPages}</span>
                {scale <= 1 && (
                  <span className="text-xs opacity-75">• Swipe to navigate</span>
                )}
              </div>
            )}

            {/* Help text */}
            {scale > 1 && (
              <div className="absolute top-4 right-4 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
                {isMobile ? 'Drag to pan' : 'Click and drag to pan'}
              </div>
            )}

            {/* Desktop keyboard navigation hint */}
            {!isMobile && numPages > 1 && (
              <div className="absolute top-4 left-4 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded">
                Use ← → arrow keys to navigate
              </div>
            )}
          </div>
        </div>

        {/* Mobile swipe hint */}
        {isMobile && numPages > 1 && (
          <div className={`text-center py-2 text-xs ${isFullscreen ? 'text-gray-400 bg-gray-800' : 'text-gray-500 bg-gray-50'} border-t ${isFullscreen ? 'border-gray-700' : 'border-gray-200'}`}>
            {scale > 1 ? 'Pinch to zoom • Drag to pan' : 'Swipe left/right to navigate pages'}
          </div>
        )}

        {/* Desktop keyboard hints */}
        {!isMobile && numPages > 1 && (
          <div className={`text-center py-2 text-xs ${isFullscreen ? 'text-gray-400 bg-gray-800' : 'text-gray-500 bg-gray-50'} border-t ${isFullscreen ? 'border-gray-700' : 'border-gray-200'}`}>
            Use arrow keys to navigate • Home/End for first/last page • Esc to close
          </div>
        )}
        {/* Mobile overlay for sidebar */}
        {isMobile && sidebarOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-50 z-10"
            onClick={() => setSidebarOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default PDFPreviewModal;